'use client';

import React, { useEffect, useState } from 'react';
import { getRuntimeOrg } from '@/utils/runtimeOrg';
import packageJson from '../../../package.json';

function titleCaseOrg(org: string) {
  return org
    .toLowerCase()
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');
}

function brandFromOrg(org: string) {
  return `${titleCaseOrg(org)}Pay`;
}

export default function FooterCopyright() {
  const [brand, setBrand] = useState<string>('');

  useEffect(() => {
    const org = (getRuntimeOrg() || 'nyandarua').toLowerCase();
    setBrand(brandFromOrg(org));
  }, []);

  return (
    <div className="mt-8 text-xs text-gray-400 flex flex-wrap items-center justify-between gap-2">
      <span>
        © {new Date().getFullYear()} {brand || 'Customer Portal'}. All rights reserved.
      </span>
      <span>v{packageJson.version}</span>
    </div>
  );
}
